import { Suspense } from 'react';
import { WidgetRenderer } from '@/app_components/widgets/WidgetRenderer';
import { getWidgetById } from '@/app_data/widgets/getWidgetById';
import type { ParserProps } from '@/app_lib/htmlParser/types';

export const WidgetParser = async ({ domNode }: ParserProps) => {
  const { attribs } = domNode;
  const widgetId = attribs['data-widget-id'];
  const widget = await getWidgetById(Number(widgetId));
  return (
    <Suspense fallback={<div />}>
      <WidgetRenderer widget={widget} />
    </Suspense>
  );
};